/*
 * Copyright (c) 2022.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {ProductTemplateFeatureValue, TemplateWithProductValues} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {TemplateFeatureService} from '../../../../pim/product/create-update/features/product-template-features/template-feature.service';

export type TemplateFeatureValue = number | number[] | string | boolean | null;
export type FeatureInfo = { groupID: number, templateFeatureID: number, error: boolean, empty: boolean };
export type SummaryFeaturesInfo = { error: boolean, empty: number, all: number, groups: { [key: number]: { empty: number, all: number } } };
export type FeatureModel = { [key: number]: TemplateFeatureValue };

@Injectable({
  providedIn: 'root'
})
export class DamItemTemplateFeaturesService extends TemplateFeatureService {

  public loadProductTemplate(damItem: number): Observable<TemplateWithProductValues> {
    return this.compoApiService.get<TemplateWithProductValues>('/dam-template/dam-item/' + damItem)
      .pipe(
        map(response => response.data),
        tap(response => this.loadDefaultValues(response)),
      );
  }

  public bindTemplate(templateID: number, damItem: number): Observable<any> {
    return this.compoApiService.post(`/template/${templateID}/bind/dam-item/${damItem}`, {})
      .pipe(map(response => response.data));
  }

  public replaceTemplate(templateID: number, damItem: number): Observable<any> {
    return this.compoApiService.post(`/template/${templateID}/replace/dam-item/${damItem}`, {})
      .pipe(map(response => response.data));
  }

  public saveProductTemplateFeatures(damItem): Observable<any> {
    const url = '/dam/template-feature-dam-item-update/' + damItem;
    return this.compoApiService.post<FeatureModel, ProductTemplateFeatureValue[]>(url, this.featureModel)
      .pipe(map(response => response.data));
  }
}
